import { gql } from "@apollo/client";

export const deleteCustomizedEarningById = gql`
  mutation DeleteCustomizedEarningById($id: String!) {
    deleteCustomizedEarningById(id: $id)
  }
`;
